export default __webpack_public_path__ + "static/media/product-tab-img.e3e2420f.svg";